<template>
  <div class="filter-header-wrapper">
    
    <header class="filter-header">
      <div class="logo-wrapper" v-if="selectedTeam">
        <img class="logo-img" :src="selectedTeam.teamLogo" alt="team logo" />
      </div>

      <div class="header-content">
        <h4 class="subheading">
          <img src="@/assets/images/activity/active-participation-icon.png" alt="active participation icon" />
          {{$t('LEADERBOARD.activeMinutes')}}
        </h4>
        <h2 class="main-heading">{{$t('LEADERBOARD.totalSessions')}}</h2>
      </div>
    </header>
    <div class="filter-wrapper">
      <div class="filter-item">
          <b-dropdown class="btn-group dropdown new-design" v-if="leaderboardData.currentTeam">
            <template slot="button-content">
              {{leaderboardData.currentTeam.name}}
            </template>

            <b-dropdown-item v-for="item in teams" :key="item.teamId">
              <span @click.prevent="selectTeamAndLog(item)">{{item.teamName}}</span>
            </b-dropdown-item>
          </b-dropdown>
      </div>
       
      <div class="filter-item">
          <b-dropdown class="btn-group dropdown new-design" v-if="leaderboardData.currentTeam || leaderboardData.fixedRow">
            <template slot="button-content">
              {{timeFrame === 'LAST_7_DAYS' ? $t('LEADERBOARD.last7days') :(timeFrame === "CURRENT_WEEK" ? $t('LEADERBOARD.thisWeek') : $t('LEADERBOARD.lastWeek'))}}
            </template>

            <b-dropdown-item v-for="item in timeFrameArr" :key="item" @click.prevent="onTimeFrameChangeAndLog(item)">
              <span>{{item === 'LAST_7_DAYS' ? $t('LEADERBOARD.last7days') : (item === "CURRENT_WEEK" ? $t('LEADERBOARD.thisWeek') : $t('LEADERBOARD.lastWeek'))}}</span>
            </b-dropdown-item>
          </b-dropdown>
      </div>

      <div class="filter-item">
        <div class="btn-group switch-btn-group switch-btn-group-orange new-design" @click.prevent="openSystemPrivacyModalAndLog">
          <label :class="`btn text-uppercase ${teamIndividual === 'team' ? 'active' : ''}`">
            {{$t('LEADERBOARD.team')}}
          </label>
          <label :class="`btn text-uppercase ${teamIndividual === 'individual' ? 'active' : ''}`">
            {{$t('LEADERBOARD.individual')}}
          </label>

          <b-modal ref="allowShareDataModal">
            <div slot="modal-header">
              <span class="modal-title">
                {{$t('LEADERBOARD.modalHeader')}}
              </span>
            </div>
            {{$t('LEADERBOARD.modalBody')}}
            <div slot="modal-footer">
              <button type="button" class="btn btn-type-3" @click="closeModal"> {{$t('LEADERBOARD.decline')}}</button>
              <button 
                type="button" 
                class="btn btn-type-4" 
                @click="onTeamIndividualChange">
                <span class="button-content">
                   {{$t('LEADERBOARD.confirm')}}
                </span>
              </button>
            </div>
          </b-modal>
        </div>
      </div>

      <div class="filter-item">
        <div class="btn-group switch-btn-group switch-btn-group-orange new-design" @click.prevent="onScopeChangeAndLog">
          <label :class="`btn text-uppercase ${scope === 'UNIVERSE' ? 'active' : ''}`">
            {{$t('LEADERBOARD.global')}}
          </label>
          <label :class="`btn text-uppercase ${scope === 'ORGANIZATION' ? 'active' : ''}`">
           {{$t('LEADERBOARD.club')}}
          </label>
        </div>
      </div>

      <div class="filter-item">
        <div class="btn-group switch-btn-group switch-btn-group-orange new-design" @click.prevent="onAggrMethodChangeAndLog">
          <label :class="`btn text-uppercase ${aggrMethod === 'AVG' ? 'active' : ''}`">
            {{$t('LEADERBOARD.average')}}
          </label>
          <label :class="`btn text-uppercase ${aggrMethod === 'SUM' ? 'active' : ''}`">
            {{$t('LEADERBOARD.total')}}
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { UPDATE_LEADERBOARD_SELECTED_TEAM, UPDATE_SYSTEM_WIDE_PRIVACY, UPDATE_ACCOUNT } from '@/store/action.types';

export default {
  name: 'FilterHeader',
 props: {
    teamIndividual : String,
    scope : String,
    aggrMethod : String,
    teams : Array,
    leaderboardData : Object,
    timeFrame : String,
    selectedTeam : Object,
    account : Object
  },
  data () {
    return {
       timeFrameArr : ['LAST_7_DAYS', 'CURRENT_WEEK', 'LAST_WEEK'],
       timeOrIndividual : 'team',
    }
  },
  methods: {
    ...mapActions({
      updateLeaderboardSelectedTeam: UPDATE_LEADERBOARD_SELECTED_TEAM,
      updateSystemWidePrivacy : UPDATE_SYSTEM_WIDE_PRIVACY,
      updateAccount : UPDATE_ACCOUNT
    }),
    openSystemPrivacyModalAndLog() {
      this.timeOrIndividual = this.teamIndividual === 'team' ? 'individual' : 'team'
      if (this.timeOrIndividual === 'individual' && this.account.systemWideActivityPrivacy) {
        this.$refs.allowShareDataModal.show()
      } else {
        this.onTeamIndividualChange()
      }
      this.$amplitude.logEvent('pwa: change leaderboard preview mode', {mode: this.teamIndividual === 'team' ? 'INDIVIDUAL' : 'TEAM'})
    },
    onTeamIndividualChange() {
      this.$refs.allowShareDataModal.hide()
      if (this.account.systemWideActivityPrivacy) {
        let accountUser = JSON.parse(window.localStorage.getItem('account'));
        this.updateSystemWidePrivacy({playerId : this.account.playerId, privacy : false})
        accountUser.systemWideActivityPrivacy = false;
        this.updateAccount(accountUser)
      }
      this.$emit('onTeamIndividualChange', this.teamIndividual === 'team' ? 'individual' : 'team', this.account.playerId);
    },
    onScopeChangeAndLog() {
      this.$emit('onScopeChange', this.scope === 'UNIVERSE' ? 'ORGANIZATION' : 'UNIVERSE', this.account.playerId)
      this.$amplitude.logEvent('pwa: change leaderboard scope', {scope: this.scope === 'UNIVERSE' ? 'CLUB' : 'GLOBAL'})
    },
    onAggrMethodChangeAndLog() {
      this.$amplitude.logEvent('pwa: change leaderboard aggregation method', {method: this.aggrMethod === 'AVG' ? 'SUM' : 'AVG'})
      this.$emit('onAggrMethodChange', this.aggrMethod === 'AVG' ? 'SUM' : 'AVG', this.account.playerId)
    },
    onTimeFrameChangeAndLog(timeFrame) {
      this.$amplitude.logEvent('pwa: change leaderboard time frame', {timeFrame: timeFrame})
      this.$emit('onTimeFrameChange', timeFrame, this.account.playerId)
    },
    selectTeamAndLog(team) {
      this.$amplitude.logEvent('pwa: change leaderboard team')
      this.updateLeaderboardSelectedTeam(team)
    },
    closeModal () {
      this.$refs.allowShareDataModal.hide()
    }
  }
}
</script>

<style lang="scss" scoped>
  .filter-header {
    display: flex;
    align-items: center;
    flex: 2;

    .main-heading {
      font-size: 22px;
    }

    .subheading {
      font-size: 12px;
      color: $luxor-gold;

      img {
        margin-right: 15px;
      }
    }
  }

  .header-content {
    display: flex;
    flex-direction: column;
    padding: 0 20px;
    justify-content: center;
  }

  .filter-header-wrapper {
    margin-bottom: 40px;
  }

  .filter-header-wrapper, .filter-wrapper {
    display: flex;
    justify-content: space-between;
  }

  .filter-wrapper {
    align-items: center;
    flex: 3;
    justify-content: flex-end;
  }

  .logo-wrapper { 
    .logo-img {
      max-width: 80px;
    }
  }

  .filter-item {
    padding: 10px;
    align-items: center;
  }

  @media screen and (max-width: 992px) {
    .filter-header-wrapper, .filter-wrapper {
      flex-wrap: wrap;
    }
  }
</style>